// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","link":"Footer_link__3Ie8d"};